import React, { useState, useCallback, useRef, useEffect } from "react";
import "react-image-crop/dist/ReactCrop.css";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Cropper from "react-easy-crop";
import Modal from "react-modal";
import styles from "./styles";
import { getCroppedImg, getRotatedImage } from "../../../utilities/canvasUtils";
import Slider from "@material-ui/core/Slider";
import Typography from "@material-ui/core/Typography";
import LachakToranjRug from "../rugTemplates/lachakToranjRug";
import AfshanRug from "../rugTemplates/afshanRug";
import KheshtiRug from "../rugTemplates/kheshtiRug";
import ModernRug from "../rugTemplates/modernRug";
const customStyles = {
  content: {
    width: "100%",
    height: "100vh",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    padding: 0,
    zIndex: 100,
    border: "none",
  },
};

export default function SelectPic({
  selectedSizeRug,
  selectTabInYourRug,
  setUserInfo,
  texts,
  selectedRugPreview,
}) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [croppedImageFile, setCroppedImageFile] = useState(null);
  const [aspect, setAspect] = useState(4 / 3);
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const inputRef = useRef();
  //const [crop, setCrop] = useState({ unit: "%", width: 0, aspect: 16 / 9 });
  const [cropModal, setCropModal] = useState(false);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [imgUri, setImageUri] = useState();
  const [defaultImage, setDefaultImage] = useState("");

  const classes = styles();
  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const readerr = new FileReader();
      readerr.addEventListener("load", () => {
        setImageUri(readerr.result);
      });
      readerr.readAsDataURL(e.target.files[0]);
      // setUserInfo({ image: e.target.files[0] });
      setAspect(selectedSizeRug.width / selectedSizeRug.height);
      setCropModal(true);
    } else {
      setImageUri(imgUri);
    }
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const urlToObject = async () => {
    const response = await fetch("./static/img/pic2.jpg");
    // here image is url/location of image
    const blob = await response.blob();
    const file = new File([blob], "image.jpg", { type: blob.type });
    setDefaultImage(file);
  };

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        imgUri,
        croppedAreaPixels,
        rotation
      );
      let img = dataURLtoFile(croppedImage, "corpet.png");
      setCroppedImageFile(img);
      setUserInfo({ image: img });
      setCroppedImage(croppedImage);
      setCropModal(false);
    } catch (e) {
      console.error(e);
    }
  }, [imgUri, croppedAreaPixels, rotation]);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio * scaleX;
    canvas.height = crop.height * pixelRatio * scaleY;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );
  }, [completedCrop]);

  useEffect(() => {
    if (selectedRugPreview) {
      urlToObject();
    }
  }, []);
  const showSelectedRug = (selectedRug) => {
    let rugtype = selectedRug.id ? selectedRug.rug_type : selectedRug.type;
    switch (rugtype) {
      case "kheshti":
        return (
          <KheshtiRug
            background={selectedRug.background}
            tile={selectedRug.tile}
            show={true}
          />
        );

      case "afshan":
        return (
          <AfshanRug
            background={selectedRug.background}
            border={selectedRug.border}
            show={true}
          />
        );

      case "modern":
        return (
          <ModernRug
            background={selectedRug.background}
            pattern={selectedRug.pattern}
            show={true}
          />
        );

      default:
        return (
          <LachakToranjRug
            background={selectedRug.background}
            border={selectedRug.border}
            corner={selectedRug.corner}
            toranj={selectedRug.toranj}
            show={true}
          />
        );

        break;
    }
  };

  return (
    <div style={{ marginTop: 50 }}>
      {selectedRugPreview ? (
        <p>عکس چیده توسط شما.لطفا دکمه تایید و ادامه را بزنید.</p>
      ) : (
        <p>
          تصویر {selectedSizeRug?.name} خود را وارد و در صورت لزوم برش بزنید
        </p>
      )}

      {selectedRugPreview ? (
        <div
          className="rotation-mobile-time"
          style={{
            width: isMobile ? "auto" : 450,
            marginTop: 30,
            marginBottom: 30,
          }}
        >
          <div className="text-center before-body-carpet relative">
            <div className="body-carpet" id="report">
              <div className="previwe">
                {showSelectedRug(selectedRugPreview)}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="my-4"
          style={{
            maxWidth: selectedSizeRug?.width,
            border: "2px dashed #06b170",
            height: selectedSizeRug?.height,
            borderRadius: 8,
            padding: 0,
            boxSizing: "content-box",
          }}
          onClick={() => inputRef.current.click()}
        >
          <div
            className="d-flex align-items-center justify-content-center your-rug-image"
            style={{
              width: "100%",
              height: "100%",
              background: croppedImage
                ? `url(${croppedImage})`
                : "rgba(6, 177, 112, 0.04)",
              color: "#2bc595",
              fontSize: 30,
              cursor: "pointer",
            }}
          >
            {!croppedImage && <span> +</span>}
          </div>
        </div>
      )}

      <div>
        <input
          type="file"
          ref={inputRef}
          style={{ display: "none" }}
          accept=".gif,.jpg,.jpeg,.png"
          onChange={onSelectFile}
        />
        {(croppedImage || selectedRugPreview) && (
          <button
            style={{
              display: "flex",
              justifyContent: "space-between",
              backgroundColor: "#2bc595",
              color: "#fff",
              alignItems: "center",
              borderRadius: 25,
              paddingRight: 16,
              position: "absolute",
              left: "50%",
              bottom: isMobile ? 54 : 69,
              transform: "translate(-50% , -50%)",
              width: 230,
              height: 40,
            }}
            onClick={() => {
              if (selectedRugPreview) {
                setUserInfo({ image: defaultImage });
              }
              selectTabInYourRug("confirm_and_pay");
            }}
          >
            <span>{texts.confirmation_and_approval}</span>
          </button>
        )}
      </div>
      <Modal
        isOpen={cropModal}
        onRequestClose={() => {
          setCropModal(false);
          setCroppedImage("");
        }}
        style={customStyles}
        overlayClassName={classes.myoverlay}
        contentLabel="Example Modal"
      >
        <div className={classes.cropContainer}>
          <Cropper
            image={imgUri}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={(e) => setCrop(e)}
            onCropComplete={onCropComplete}
            onZoomChange={(e) => setZoom(e)}
          />
        </div>
        <div className={classes.controls}>
          <div className={classes.sliderContainer}>
            <Typography
              variant="overline"
              classes={{ root: classes.sliderLabel }}
            >
              {texts.zoom}
            </Typography>
            <Slider
              value={zoom}
              min={1}
              max={3}
              step={0.1}
              aria-labelledby="بزرگنمایی"
              classes={{ container: classes.slider }}
              onChange={(e, zoom) => setZoom(zoom)}
              color="secondary"
            />
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            style={{
              backgroundColor: "#06b170",
              color: "#fff",
              padding: 10,
              borderRadius: 4,
            }}
            onClick={showCroppedImage}
          >
            <p>{texts.image_registration}</p>
          </button>
        </div>
      </Modal>
    </div>
  );
}
